export default "__VITE_ASSET__b1095cee__"